import { css } from '@emotion/react';
// Constants
import { Color } from "../../constants/Colors";
import { SVG_GRADIENT_BLUE } from '../Button/ButtonStyles';

export const useStyles = (props) => ({
    userAccountBox: css({
        position: "relative",
        boxSizing: "border-box",
        width: '376px',
        height: '442px',
        paddingBottom: '75px',
        backgroundSize: '0% 100%',
        backgroundRepeat: 'no-repeat',
        backgroundOrigin: 'border-box',
        border: `4px solid ${Color.primary[600]}`,
        borderImage: `url('data:image/svg+xml;base64,${SVG_GRADIENT_BLUE}') 10% stretch`,
        backgroundColor: 'transparent',
        transition: 'all .2s ease-in-out',
        display: 'block',
        textAlign: 'center',
        textOverflow: 'ellipsis',
        "& svg": {
            position: 'absolute',
            top: '8px',
            right: '12px',
            color: Color.primary[500],
        },
    }),
    userAccountPicture: css({
        display: 'inline-block',
        width: '152px',
        height: '152px',
        borderRadius: '50%',
        backgroundColor: Color.neutral[200],
        marginTop: '70px',
    }),
});
